<template>
    <div>
        <v-list>
            <v-list-item>
                <v-list-item-title>
                    {{ $t('Kansikuvat') }}
                </v-list-item-title>
            </v-list-item>
            <draggable v-if="wallpapers.length" v-model="wallpapers" tag="div" handle=".handle" ghost-class="ghost"
                @end="sort">
                <v-list-item v-for="w in wallpapers" :key="w.id">
                    <v-list-item-icon>
                        <v-icon class="handle mr-4">
                            {{ icons.mdiCursorMove }}
                        </v-icon>
                        <v-img :src="w.image.thumbnail" width="140"></v-img>
                    </v-list-item-icon>
                    <v-list-item-title class="ml-5 pl-10">{{ w.name }}</v-list-item-title>
                    <v-list-item-action>
                        <v-btn color="error mr-4" small @click="deleteWallpaper(w.id)">{{ $t('Poista') }}</v-btn>
                    </v-list-item-action>
                </v-list-item>
            </draggable>
            <v-list-item v-if="wallpapers.length > 1" dense>
                <v-list-item-content>
                    <v-alert color="primary" text :icon="icons.mdiInformation">
                        {{ $t('Kuvat näytetään kuvakarusellissa') }}
                    </v-alert>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="wallpapers.length < 5" dense>
                <v-list-item-content>
                    <v-file-input :label="$t('Lisää uusi kansikuva')" @change="saveImage"
                        :hint="'Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px'" persistent-hint
                        accept=".jpeg,.jpg,.png"></v-file-input>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-else dense>
                <v-list-item-content>
                    <v-alert color="primary" text :icon="icons.mdiInformation">
                        {{ $t('Enintään 5 kuvaa voidaan lisätä') }}
                    </v-alert>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { onMounted, ref, nextTick } from "@vue/composition-api";
import adminApi from '@/api/admin';
import { VListItemIcon } from "vuetify/lib";
import { i18n } from "@/plugins/i18n";
import {
    mdiCursorMove,
    mdiInformation
} from "@mdi/js";
import draggable from "vuedraggable";

export default {
    components: {
        draggable,
    },
    props: {
        categoryId: {
            type: Number,
            default: null
        }
    },
    setup(props) {
        const wallpapers = ref([]);

        const fetchWallpapers = async () => {
            const response = await adminApi.getWallpapers(props.categoryId);
            if (response.ok) {
                wallpapers.value = response.data;
            }
        }

        const saveImage = async (imageFile) => {
            if (imageFile) {
                const response = await adminApi.saveWallpaper(imageFile, props.categoryId);
                if (response.ok) {
                    fetchWallpapers();
                }
                else {
                    alert(JSON.stringify(response.data));
                }
            }
        };

        const deleteWallpaper = async (id) => {
            if (confirm(i18n.t('Haluatko varmasti poistaa kuvan?'))) {
                const response = await adminApi.deleteWallpaper(id);
                if (response.ok) {
                    fetchWallpapers();
                }
                else {
                    alert(JSON.stringify(response.data));
                }
            }
        }

        const sort = async () => {
            const ids = wallpapers.value.map(a => a.id);
            const response = await adminApi.sortWallpapers(ids);
            if (!response.ok)
                fetchWallpapers();
        }

        onMounted(() => {
            fetchWallpapers();
        });

        return {
            wallpapers,
            saveImage,
            deleteWallpaper,
            sort,
            icons: {
                mdiCursorMove,
                mdiInformation
            }
        }
    }
}
</script>

<style></style>
